import { Textarea } from '@mantine/core';

import classes from './index.module.css';

interface ITextAreaFilled {
    placeholder: string,
}

const TextAreaFilled = ({ placeholder, ...props }: ITextAreaFilled) => {
    return (
        <Textarea variant='filled' placeholder={placeholder} classNames={{ input: classes.input, wrapper: classes.wrapper }} {...props} />
    )
}

export default TextAreaFilled;